export class MapTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        markeraAvmarkera: "Markera",
        rita: "Rita",
        mat: "Mät",
        lokaliseraGeometrier: "Lokalisera geometrier",
        lagervaljare: "Lager",
        lassoinstruktioner: "Tryck och håll nere vänster musknapp för att markera med lasso.",
        avmarkeraAllt: "Avmarkera",
        fullscreen: "Helskärm"
    };
}
